import { WorshipReport } from '../types/worshipReport';
import { FinanceReport } from '../types/financeReport';

export function calculateRegularAttendance(attendance: WorshipReport['attendance']): number {
  return (
    attendance.adults.men +
    attendance.adults.women +
    attendance.children.boys +
    attendance.children.girls +
    attendance.blooms
  );
}

export function calculateNewMembersTotal(newMembers: WorshipReport['newMembers']): number {
  return (
    newMembers.men +
    newMembers.women +
    newMembers.blooms +
    newMembers.children
  );
}

export function calculateTotalParticipants(data: Partial<WorshipReport>): number {
  if (!data.attendance) return 0;
  
  // Only count regular attendance, excluding "Nouveaux reçus"
  return calculateRegularAttendance(data.attendance);
}

export function calculateTotalFinances(finances: FinanceReport['finances']): number {
  return finances.tithes + finances.regularOfferings + finances.specialOfferings;
}